import { StorageKeys, storageService } from '@/utils/localStorageService'

/**
 * One anonymous id per browser. Random, never derived from anything the person typed.
 *
 * Lives on its own because two readers need it and must agree: Amplitude (every event carries it)
 * and the A/B arm (assigned from its hash, so the same browser lands in the same arm even if the
 * routing cookie is lost). Deriving the arm from anything else — time, a second random — would let
 * one person see both algorithms and count in both.
 */
export const deviceId = (): string => {
  const stored = storageService.getItem<string>(StorageKeys.device)
  if (stored) return stored
  const fresh = crypto.randomUUID()
  storageService.setItem(StorageKeys.device, fresh)
  return fresh
}
